import React from "react";
import ContentLoader from "react-content-loader";

const DebtReportLoader = () => (
  <ContentLoader
    speed={2}
    width={500}
    height={130}
    viewBox="0 0 500 130"
    backgroundColor="#f3f3f3"
    foregroundColor="#ecebeb"
  >
    <rect x="20" y="25" rx="3" ry="3" width="300" height="10" />
    <rect x="350" y="25" rx="3" ry="3" width="100" height="10" />

    <rect x="20" y="55" rx="3" ry="3" width="300" height="10" />
    <rect x="350" y="55" rx="3" ry="3" width="100" height="10" />

    <rect x="20" y="85" rx="3" ry="3" width="300" height="10" />
    <rect x="350" y="85" rx="3" ry="3" width="100" height="10" />

    <rect x="20" y="115" rx="3" ry="3" width="300" height="10" />
    <rect x="350" y="115" rx="3" ry="3" width="100" height="10" />
  </ContentLoader>
);

export default DebtReportLoader;
